import { CorePartialStoreState, CORE_STATE_KEY } from './core.reducer';

export const getRegionLanguage = (state: CorePartialStoreState) => state[CORE_STATE_KEY].region.languages;

export const getRegionCountryCode = (state: CorePartialStoreState) => state[CORE_STATE_KEY].region.country_code;

export const getRegionResetTicketsTime = (state: CorePartialStoreState) =>
    state[CORE_STATE_KEY].region.reset_offline_tickets_list_time_min;

export const getSelectedLanguage = (state: CorePartialStoreState) => state[CORE_STATE_KEY].selectedLanguage;
